import {CurrentUser} from '../../shared/models/current-user.model';

export class UpdateCurrentUser {
    static readonly type = '[Current User] Update';

    constructor(public payload: CurrentUser) {}
}

